import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const Department = () => {
  const [departments, setDepartments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchDepartments = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/get-categories`
      );
      const data = await res.json();
      setDepartments(data.categories);
    } catch (err) {
      console.error("Error fetching departments:", err);
    }
  };

  const fetchDoctors = async (departmentId = null) => {
    try {
      const url = departmentId
        ? `${process.env.REACT_APP_API_URL}/get-doctor/${departmentId}`
        : `${process.env.REACT_APP_API_URL}/get-doctors`;

      const res = await fetch(url);
      const data = await res.json();
      setDoctors(data.doctors || []);
      setFilteredDoctors(data.doctors || []);
    } catch (err) {
      console.error("Error fetching doctors:", err);
    }
  };

  useEffect(() => {
    fetchDepartments();
    fetchDoctors();
  }, []);

  const handleDeptClick = (id) => {
    setSelectedDept(id);
    fetchDoctors(id);
    setSearchTerm(""); // Reset search when filtering by department
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = doctors.filter((doc) =>
      `${doc.name} ${doc.specialization} ${doc.email}`
        .toLowerCase()
        .includes(value)
    );
    setFilteredDoctors(filtered);
  };

  return (
    <Container className="mt-5 py-5" style={{ backgroundColor: "#f0f8ff", minHeight:'80vh', height:'auto' }}>
      <h1 className="text-center text-primary mb-4">Doctors by Department</h1>

      {/* Search and Department Filter in One Row */}
      <div className="mb-4 d-flex justify-content-center flex-wrap gap-3">
        {/* Search Input */}
        <input
          type="text"
          placeholder="Search doctors by name, department, or email..."
          className="form-control"
          value={searchTerm}
          onChange={handleSearchChange}
          style={{
            borderRadius: "30px",
            padding: "10px 20px",
            minWidth: "300px",
            maxWidth: "400px",
            flex: "1",
          }}
        />

        {/* Department Dropdown Filter */}
        <div className="dropdown">
          <button
            className="btn btn-outline-info btn-lg rounded-pill dropdown-toggle px-4 py-2 shadow-sm"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{ fontWeight: "500", fontSize: "1rem" }}
          >
            {selectedDept
              ? departments.find((d) => d.id === selectedDept)?.name
              : "Filter by Department"}
          </button>

          <ul
            className="dropdown-menu shadow p-2 mt-2 border-0 rounded-4"
            style={{ maxHeight: "250px", overflowY: "auto", minWidth: "250px" }}
          >
            <li>
              <button
                className={`dropdown-item rounded-pill px-3 py-2 ${
                  selectedDept === null ? "active text-white bg-info" : ""
                }`}
                onClick={() => handleDeptClick(null)}
              >
                All Departments
              </button>
            </li>
            {departments.map((dept) => (
              <li key={dept.id}>
                <button
                  className={`dropdown-item rounded-pill px-3 py-2 ${
                    selectedDept === dept.id ? "active text-white bg-info" : ""
                  }`}
                  onClick={() => handleDeptClick(dept.id)}
                >
                  {dept.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Doctors Cards */}
      <Row xs={1} md={2} lg={4} className="g-4 mt-3">
        {filteredDoctors.length > 0 ? (
          filteredDoctors.map((doctor) => (
            <Col key={doctor.id} style={{ margin: "30px auto" }}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Img
                  variant="top"
                  src={
                    doctor.profile_pic
                      ? `${process.env.REACT_APP_API_URL}/${doctor.profile_pic}`
                      : "https://via.placeholder.com/150"
                  }
                  alt="Profile"
                  style={{
                    height: "250px",
                    objectFit: "cover",
                  }}
                />
                <Card.Body className="p-4" style={{ backgroundColor: "white" }}>
                  <Card.Title className="fw-bold text-primary">
                    {doctor.name}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {departments.find(
                      (dept) => dept.id === parseInt(doctor.department_id)
                    )?.name || "N/A"}
                  </Card.Subtitle>
                  <Card.Text>
                    <strong>Email:</strong> {doctor.email}
                    <br />
                    <strong>Contact:</strong> {doctor.contact}
                    <br />
                    <strong>Description:</strong> {doctor.description}
                  </Card.Text>
                  <Link
                    to={`/appointment/${doctor.user_id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <button className="btn btn-sm btn-outline-primary fw-bold">
                      Book Appointment
                    </button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <Col className="col-12">
            <p className="text-center text-muted">No doctors found.</p>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default Department;
